import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Articles() {
  const { t, i18n } = useTranslation();
  const articles = t("articlesList", { returnObjects: true }) as Array<{
    slug: string;
    title: string;
    desc: string;
    date: string;
  }>;
  const currentLang = i18n.language;

  return (
    <section id="articles" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            {t("home.articles.title")}
          </h2>
          <p className="text-gray-600">{t("home.articles.subtitle")}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/${currentLang}/article/${article.slug}`}
              className="group block rounded-xl bg-gray-50 hover:bg-emerald-50 transition-all border border-gray-100 hover:border-emerald-200 overflow-hidden"
            >
              <div className="p-6">
                <div className="flex items-center gap-2 text-xs text-gray-500 mb-3">
                  <i className="ri-calendar-line" />
                  {article.date}
                  <span className="w-1 h-1 rounded-full bg-gray-300" />
                  <span className="text-emerald-700 font-medium">{t("article.meta.author")}</span>
                </div>
                <h3 className="font-semibold text-gray-900 group-hover:text-emerald-700 transition-colors mb-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">{article.desc}</p>
                <div className="mt-4 flex items-center gap-1 text-sm font-medium text-emerald-700">
                  {t("cta.readMore")}
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}